import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import urlJoin from 'url-join';
import { bearer, responseData } from '@@client/lib/request';
import { tokenRequest } from '@@client/lib/token-cache';
export function revokeSession(_x, _x2, _x3) {
  return _revokeSession.apply(this, arguments);
}

function _revokeSession() {
  _revokeSession = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenCache, apiUrl, id) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", tokenRequest(tokenCache, function (token) {
              return fetch(urlJoin(apiUrl, '/api/v1/account/session/own', id, 'revoke'), {
                method: 'delete',
                headers: {
                  'Authorization': bearer(token),
                  'Content-Type': 'application/json'
                }
              }).then(responseData).then(function (_ref) {
                var response = _ref.response,
                    data = _ref.data;

                if (response.ok) {
                  return {
                    success: true,
                    entity: data
                  };
                } else {
                  return {
                    success: false,
                    errors: data.errors
                  };
                }
              });
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _revokeSession.apply(this, arguments);
}